module.exports = __webpack_public_path__ + "img/suenching_kapelle_raum_2015_ref.f595ddf2.jpg";